export const localization = {
  pt: {
    title: 'Gerenciar URL',
    subtitle: 'Gerencie páginas de URL para controlar as referências usadas pelos agentes.',
    searchPlaceholder: 'Buscar páginas...',
    breadcrumbs: {
      home: 'Início',
      knowledgeBase: 'Base de Conhecimento',
    },
    tableHeaders: {
      pages: 'Páginas',
      synchronization: 'Sincronização',
      actions: 'Ações',
    },
    deleteVersionAlert: {
      body: 'Ao excluir esta página, os Agentes de IA poderão perder referências importantes para algumas respostas.<br/><br/>Deseja excluir mesmo assim?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Excluir',
      },
      title: 'Excluir página',
    },
    successUpdateVersionStatusToast: {
      message: 'Status da página foi atualizado com sucesso.',
      title: 'Página atualizada',
    },
    errorUpdateVersionStatusToast: {
      message: 'Não foi possível atualizar o status da página. Tente novamente.',
      title: 'Falha ao atualizar',
    },
    successUpdateVersionNameToast: {
      message: 'Título da página foi atualizado com sucesso.',
      title: 'Página atualizada',
    },
    errorUpdateVersionNameToast: {
      message: 'Não foi possível atualizar o título da página. Tente novamente.',
      title: 'Falha ao atualizar',
    },
    successDeleteVersionToast: {
      message: 'A página foi removida da URL e não está mais disponível no catálogo.',
      title: 'Página excluída',
    },
    errorDeleteVersionToast: {
      message: 'Não foi possível remover a página da URL. Tente novamente.',
      title: 'Falha ao excluir',
    },
    urlPathMoreOptions: {
      view: 'Visualizar',
      delete: 'Excluir',
    },
  },
  en: {
    title: 'Manage URL',
    subtitle: 'Manage URL pages to control the references used by agents.',
    searchPlaceholder: 'Search pages...',
    breadcrumbs: {
      home: 'Home',
      knowledgeBase: 'Knowledge Base',
    },
    tableHeaders: {
      pages: 'Pages',
      synchronization: 'Synchronization',
      actions: 'Actions',
    },
    deleteVersionAlert: {
      body: 'By deleting this page, AI Agents may lose important references for some responses.<br/><br/>Do you want to delete anyway?',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Delete',
      },
      title: 'Delete page',
    },
    successUpdateVersionStatusToast: {
      message: 'Page status updated successfully.',
      title: 'Page updated',
    },
    errorUpdateVersionStatusToast: {
      message: 'Could not update page status. Please try again.',
      title: 'Failed to update',
    },
    successUpdateVersionNameToast: {
      message: 'Page title updated successfully.',
      title: 'Page updated',
    },
    errorUpdateVersionNameToast: {
      message: 'Could not update page title. Please try again.',
      title: 'Failed to update',
    },
    successDeleteVersionToast: {
      message: 'The page has been removed from the URL and is no longer available in the catalog.',
      title: 'Page deleted',
    },
    errorDeleteVersionToast: {
      message: 'Could not remove the page from the URL. Please try again.',
      title: 'Failed to delete',
    },
    urlPathMoreOptions: {
      view: 'View',
      delete: 'Delete',
    },
  },
  es: {
    title: 'Administrar URL',
    subtitle: 'Administre páginas de URL para controlar las referencias utilizadas por los agentes.',
    searchPlaceholder: 'Buscar páginas...',
    breadcrumbs: {
      home: 'Inicio',
      knowledgeBase: 'Base de Conocimiento',
    },
    tableHeaders: {
      pages: 'Páginas',
      synchronization: 'Sincronización',
      actions: 'Acciones',
    },
    deleteVersionAlert: {
      body: 'Al eliminar esta página, los Agentes de IA pueden perder referencias importantes para algunas respuestas.<br/><br/>¿Desea eliminar de todos modos?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Eliminar',
      },
      title: 'Eliminar página',
    },
    successUpdateVersionStatusToast: {
      message: 'Estado de la página actualizado exitosamente.',
      title: 'Página actualizada',
    },
    errorUpdateVersionStatusToast: {
      message: 'No se pudo actualizar el estado de la página. Inténtelo de nuevo.',
      title: 'Falló al actualizar',
    },
    successUpdateVersionNameToast: {
      message: 'Título de la página actualizado con éxito.',
      title: 'Página actualizada',
    },
    errorUpdateVersionNameToast: {
      message: 'No se pudo actualizar el título de la página. Inténtelo de nuevo.',
      title: 'Falló al actualizar',
    },
    successDeleteVersionToast: {
      message: 'La página ha sido eliminada de la URL y ya no está disponible en el catálogo.',
      title: 'Página eliminada',
    },
    errorDeleteVersionToast: {
      message: 'No se pudo eliminar la página de la URL. Inténtelo de nuevo.',
      title: 'Falló al eliminar',
    },
    urlPathMoreOptions: {
      view: 'Ver',
      delete: 'Eliminar',
    },
  },
};
